import {
  academyDetailQueryKey,
  academyListQueryKey,
  academyRegionQueryKey,
} from '@/lib/academy-list';
import { useQuery } from '@tanstack/react-query';
import {
  getAcademyDetail,
  getAcademyList,
  getAcademyRegionList,
} from '../academy.services';
import { ApiResponse } from '../base-api';
import {
  AcademyEntity,
  AcademyListResponse,
  AcademyRegionEntity,
  GetAcademyListParams,
} from '../types/academy.type';

// 서버에서 같은 키로 프리페치한 데이터가 있으면 곧바로 그 값을 돌려주어 첫 렌더가 HTML에 실린다.
export const useAcademyList = (params?: GetAcademyListParams) => {
  return useQuery<ApiResponse<AcademyListResponse>>({
    queryKey: academyListQueryKey(params),
    queryFn: () => getAcademyList(params),
  });
};

export const useAcademyDetail = (id: number) => {
  return useQuery<ApiResponse<AcademyEntity>>({
    queryKey: academyDetailQueryKey(id),
    queryFn: () => getAcademyDetail(id),
    enabled: !!id,
  });
};

export const useAcademyRegionList = () => {
  return useQuery<ApiResponse<AcademyRegionEntity[]>>({
    queryKey: academyRegionQueryKey(),
    queryFn: () => getAcademyRegionList(),
  });
};
